import React from 'react';
import './LoadingSpinner.css';

interface LoadingSpinnerProps {
  themeStyles?: Record<string, string>;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ themeStyles }) => {
  return (
    <div 
      className="loading-container"
      style={themeStyles || {}}
    >
      <div className="loading-spinner">
        <div className="spinner-ring"></div>
        <div className="spinner-ring"></div>
        <div className="spinner-ring"></div>
      </div>
      <p className="loading-text">Loading schedule...</p>
    </div>
  );
};

export default LoadingSpinner;
